import React, { useEffect, useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePickerMat.css";

const DatePickerMat = ({ label, onChange, defaultValue }) => {
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const handleValueChange = (newValue) => {
    console.log("newValue:", newValue);
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <>
      <div className="pt-3">
        <div className="border-[1px] date-picker-container relative rounded-[0.3rem] transition-all ease-in-out duration-100 placeholder-text-seondary-color text-text-primary-color border-secondary-color focus:border-secondary-color outline-0 font-lato text-[1rem] w-full leading-normal  py-[0.3rem] ">
          <Datepicker
            primaryColor={"cyan"}
            asSingle={true}
            useRange={false}
            value={value}
            onChange={handleValueChange}
          />

          <label className="absolute font-normal text-[0.75rem] -translate-y-1/2 -top-[2px] left-4 bg-white px-2 font">
            {label}
          </label>
        </div>
      </div>
    </>
  );
};

export default DatePickerMat;
